import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * AppTourService used to manage communication between TourInterceptor and TourModule.
 * Without the need to import anything from TourModule in the CoreModule.
 */
@Injectable({ providedIn: 'root' })
export class AppTourService {
  /** Tour requests buffer source */
  lastRequest$: Observable<{ url: string; params: HttpParams }>;

  /** ReplaySubject is used as a buffer here to keep the requests for the late subscription  */
  private _requestsBuffer$ = new ReplaySubject<{
    url: string;
    params: HttpParams;
  }>(5);

  /** Response state */
  private _responseSub$ = new BehaviorSubject<{ [key: string]: any }>({});

  constructor() {
    this.lastRequest$ = this._requestsBuffer$.asObservable();
  }

  fetchTourRequest(url: string, params: HttpParams): void {
    this._requestsBuffer$.next({ url, params });
  }

  setTourResponse(url: string, data: any): void {
    this._responseSub$.next({ ...this._responseSub$.value, [url]: data });
  }

  getTourResponse(url: string): Observable<any> {
    return this._responseSub$.pipe(map((response) => response[url]));
  }
}
